import { render } from "./CrashFilePagePrint.vue?vue&type=template&id=f3f577e0&ts=true"
import script from "./CrashFilePagePrint.vue?vue&type=script&lang=ts"
export * from "./CrashFilePagePrint.vue?vue&type=script&lang=ts"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__